<div class="confirm-modal">
  <p class="confirm-modal__title">{{ title }}</p>
  <p class="confirm-modal__description">{{ description }}</p>
</div>
